import type { InputMaybe, SubOptionItemInput } from "@/lib/gql/__generated__/graphql";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";
import { QuestionCardItem } from "@/components/features/items/edit/_shared/ui/components/system/question/card/card-item";
import { QuestionCardItemsWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/card/card-items-wrapper";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { FormItem } from "@/components/ui/form/_base/form";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

const REASON_READONLY = "日本語版 編集画面で設定してください";

const noopRemove = () => {};

const isShowTimeScheduleText = (isShowTimeSchedule: boolean) =>
	isShowTimeSchedule ? "予約画面で時間帯を表示する" : "予約画面で時間帯を表示しない";
const isNextMorningText = (isNextMorning: boolean) =>
	isNextMorning ? "翌朝のオプションとして設定する" : "翌朝のオプションとして設定しない";

type Props = {
	subOptions: ForArrayType<InputMaybe<SubOptionItemInput[]> | undefined> | undefined;

	onSetSubOptionName: (name: string, index: number) => void;
};

export const QuestionOptionSubOptions = ({ subOptions, onSetSubOptionName }: Props) => {
	const appendItem = () => {};
	const disabled = true;

	const reasonForCannotAppendItem = "日本語版 編集画面で設定してください";

	return (
		<QuestionCardItemsWrapper
			appendItem={appendItem}
			disabled={{ value: disabled, reason: reasonForCannotAppendItem }}
		>
			<FormItem>
				{subOptions?.value?.map((item, index) => {
					return (
						<QuestionCardItem
							key={item.subOptionID?.value ?? index}
							removeItem={noopRemove}
							canRemoveItem={false}
							reasonForCannotRemoveItem={REASON_READONLY}
						>
							<div className="flex flex-col gap-y-6">
								<p className="font-semibold underline underline-offset-2">ID: {item.subOptionID?.value}</p>
								<QuestionSectionWrapper>
									<InputTextField
										className="w-full"
										label="サブオプション名"
										value={item.name.value}
										errorMessage={item.name.error}
										handleChange={(input) => onSetSubOptionName(input, index)}
									/>
								</QuestionSectionWrapper>

								<Accordion type={"single"} collapsible>
									<AccordionItem value={item.subOptionID?.value ?? `${index}`}>
										<AccordionTrigger>時間や料金の設定</AccordionTrigger>

										<AccordionContent>
											<div className="ml-6 flex flex-col gap-y-12">
												<div className="flex flex-col gap-y-6">
													<p className="text-brand">※ 太字は「日本語」編集画面で設定した項目です。</p>
													<QuestionSectionWrapper>
														<p className="text-lg font-semibold">
															{isShowTimeScheduleText(item.isShowTimeSchedule?.value ?? false)}
														</p>
													</QuestionSectionWrapper>

													<div className="ml-4">
														<div className="flex items-center gap-x-6">
															<QuestionSectionWrapper>
																<p>開始</p>
																<p className="text-lg font-semibold">
																	{item.startAt?.value ? item.startAt?.value : "未設定"}
																</p>
															</QuestionSectionWrapper>
															<p>〜</p>
															<QuestionSectionWrapper>
																<p>終了</p>
																<p className="text-lg font-semibold">
																	{item.endAt?.value ? item.endAt?.value : "未設定"}
																</p>
															</QuestionSectionWrapper>
														</div>
													</div>

													<div>
														<QuestionSectionWrapper>
															<p className="text-lg font-semibold">
																{isNextMorningText(item.isNextMorning?.value ?? false)}
															</p>
														</QuestionSectionWrapper>
													</div>
												</div>

												<div className="flex flex-col gap-y-4">
													<QuestionSectionWrapper>
														<p>１日あたり</p>

														<p className="text-lg font-semibold">{item.maxDailyStockNum.value}</p>
														<p>個まで販売可能</p>
													</QuestionSectionWrapper>
													<QuestionSectionWrapper>
														<p>１個あたり</p>
														<p className="text-lg font-semibold">
															{item.price.amount.value.toLocaleString()}
														</p>
														<p>円</p>
													</QuestionSectionWrapper>
												</div>
											</div>
										</AccordionContent>
									</AccordionItem>
								</Accordion>
							</div>
						</QuestionCardItem>
					);
				})}
			</FormItem>
		</QuestionCardItemsWrapper>
	);
};
